import FormInput from '@/components/Form/FormInput';
import FormInputPassword from '@/components/Form/FormInputPassword';
import { FormInModal, IconFont } from '@/components';
import { Form } from 'antd';
import { ChangeEvent, FC, useState } from 'react';
import VerificationInput from './passwordAccountForm/VerificationInput';
import { EIGHT_SIXTEEN_PASSWORD_REG } from '@lhb/regexp';
import { get } from '@/common/request';
import styles from '../login/index.module.less';

const { Item, useForm } = Form;

interface ChangePasswordProps {
  visible: boolean;
  [key: string]: any
}

const ChangePassword: FC<ChangePasswordProps> = (props) => {
  const { visible, ...restProps } = props;
  const [mobile, setMobile] = useState<string>('');
  const [form] = useForm();
  const [isStart, setIsStart] = useState<boolean>(false);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { target } = e;
    const { value } = target;
    setMobile(value as string);
  };

  const onSend = async() => {
    if (!form) {
      return;
    }

    const data = await get('/sendCode', { mobile }, { proxyApi: '/mirage', needHint: true }).catch(() => {
      setIsStart(false);
    });
    if (data) {
      window.microMessage.success('短信发送成功');
      setIsStart(true);
    }
  };

  const onStart = () => {
    setIsStart(false);
  };

  return (
    <FormInModal
      visible={visible}
      url='/account/forgetPassword'
      proxyApi='/mirage'
      title='找回密码'
      {...restProps}
    >
      <Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
        <FormInput
          label='手机号'
          name='mobile'
          config={
            {
              value: mobile,
              onChange: onChange,
              prefix: (<IconFont iconHref='res-servise-ic_phone' className={styles.icon}/>)
            }
          }/>
        <Item
          label='验证码'
          name='code'>
          <VerificationInput
            onClick={onSend}
            isStart={isStart}
            onStart={onStart}
          />
        </Item>
        <FormInputPassword
          label='密码'
          name='password'
          rules={[
            { required: true, message: '请输入密码' },
            { pattern: EIGHT_SIXTEEN_PASSWORD_REG, message: '请输入8-16位数字+字母组合' },
          ]}
        />
        <FormInputPassword
          label='确认密码'
          name='rePassword'
          rules={[
            { required: true, message: '请输入密码' },
            { pattern: EIGHT_SIXTEEN_PASSWORD_REG, message: '请输入8-16位数字+字母组合' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('两次输入密码不一致'));
              },
            }),
          ]}
        />
      </Form>
    </FormInModal>
  );
};

export default ChangePassword;
